/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportSupportFlowActivity} from '../api'

export const useMutationReportSupportFlowActivity = createReactQueryMutationHook('reportSupportFlowActivity', reportSupportFlowActivity)
